import { v3 as uuidv3 } from "uuid";

const NAMESPACE_DNS = uuidv3.DNS;

export function buildUuid(answers: unknown, dimensions: unknown): string {
  const payload = {
    answers,
    dimensions,
  };
  const json = JSON.stringify(payload);
  return uuidv3(json, NAMESPACE_DNS);
}
